import { NgModule } from '@angular/core';

import { PincodeModule } from '@ap/tokens-browser';

import { PincodeWrapperComponent } from './pincode.wrapper.component';

/**
 * @name PincodeWrapperModule
 * @ngdoc module
 */
@NgModule({
    declarations: [PincodeWrapperComponent],
    imports: [PincodeModule],
    exports: [PincodeWrapperComponent]
})
export class PincodeWrapperModule {}
